<mat-accordion>
  <mat-expansion-panel
    class="mat-elevation-z0"
    [hideToggle]="true" 
    [disabled]="!habilitado"
    (opened)="estadoDeAberturaDoPainel = true; expandidoChange.emit(true)"
    (closed)="estadoDeAberturaDoPainel = false; expandidoChange.emit(false)"
    [expanded]="estadoDeAberturaDoPainel"
  >
    <mat-expansion-panel-header 
      class="header"
      [class.expanded]="estadoDeAberturaDoPainel" >
      <mat-panel-title class="title">
        <img class="chevron px-4" [src]="'assets/icons/down.svg'"/>
        <span class="title-text">{{ titulo }}</span>
      </mat-panel-title>

      <img class="chevron py-4" [src]="'assets/icons/down.svg'"/>
    </mat-expansion-panel-header>
    <ng-container *ngIf="estadoDeAberturaDoPainel">
      <ng-content></ng-content>
    </ng-container>
  </mat-expansion-panel>
</mat-accordion>
